<template>
  <v-form ref="registryForm">
    <v-row dense>
      <v-col cols="12">
        <int-editor validate-on-blur v-model="data.mobile" dense outlined class="rounded-0" autocomplete="off" label="手机号" :rules="[rules.required,rules.mobile]"></int-editor>
      </v-col>
      <v-col cols="12">
        <int-editor validate-on-blur v-model="data.smsCode" dense label="验证码" outlined class="rounded-0" autocomplete="off" :rules="[rules.required]">
          <template v-slot:append>
            <div style="margin-top:-3px;">
              <v-btn color="primary" small class="caption" :disabled="smsCodeDisabled" elevation=0 @click="onGetRegistrySmsCode">{{smsCodeText}}</v-btn>
            </div>
          </template>
        </int-editor>
      </v-col>
      <v-col cols="12">
        <v-text-field v-model="data.name" dense outlined class="rounded-0" :rules="[rules.required]" label="姓名"></v-text-field>
      </v-col>
      <v-col cols="12">
        <v-text-field validate-on-blur v-model="data.password" dense type="password" autocomplete="off" outlined class="rounded-0" label="请设置您的登录密码(区分大小写)" :rules="[rules.required,rules.password]"></v-text-field>
      </v-col>
      <v-col cols="12">
        <v-text-field validate-on-blur v-model="data.rePassword" dense type="password" autocomplete="off" outlined class="rounded-0" label="请再次输入登录密码(区分大小写)" :rules="[rules.required,rules.password,rules.same]"></v-text-field>
      </v-col>
      <v-col cols="12">
        <v-text-field validate-on-blur v-model="data.email" dense outlined class="rounded-0" label="邮箱" :rules="[rules.required,rules.email]"></v-text-field>
      </v-col>
      <v-col cols="12">
        <v-text-field v-model="data.workUnit" dense outlined class="rounded-0" label="工作单位（选填）"></v-text-field>
      </v-col>
      <v-col cols="12" v-if="registryVerifyCode">
        <v-row dense>
          <v-col cols="7">
            <v-text-field validate-on-blur v-model="data.verifyCode" dense outlined class="rounded-0" autocomplete="off" label="图片验证码" :rules="[rules.required]"></v-text-field>
          </v-col>
          <v-col cols="5">
            <v-img :src="verifyCodeUrl" @click="onRefreshVerifyCode" contain height="37"></v-img>
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="12">
        <v-row justify="center" align="center" no-gutters>
          <v-col cols="2" class="subtitle-2">兴趣标签</v-col>
          <v-col>
            <v-chip small v-for="(item,index) in coder_CLOUD_TAGS" :close="item.default===false" @click:close="onTagRemove(index)" :key="index" @click="onToggleTag(item)" class="ma-1" :color="tagSelected(item)?'primary':''">
              {{item.name}}
            </v-chip>
            <mini-text-editor v-if="tagAddFlag" v-focus ref="tagAddEditor" @change="onTagAddOk" width="48"></mini-text-editor>
            <a v-if="!tagAddFlag" class="caption ml-2" @click="onTagAdd">添加</a>
          </v-col>
        </v-row>

      </v-col>
    </v-row>
  </v-form>

</template>
<script>
/* eslint-disable no-console */
import { getCoder, getRegistrySmsCode } from '@/plugins/api';
import { required, password, mobile, email } from '@/plugins/rules';

import md5 from 'md5';

export default {
  props: {
    registryVerifyCode: { type: Boolean, default: false }
  },
  data () {
    return {
      verifyCodeUrl: `${this.Utility.userApi}/api/pub/verify/code?ts=${new Date().getTime()}`,
      coder_CLOUD_TAGS: [],
      tagAddFlag: false,
      data: { tags: [] },
      smsCodeText: '获取验证码',
      smsCodeDisabled: false,
      rules: {
        required: required(), password: password(), mobile: mobile(), email: email(),
        same: (v) => {
          return (v && v == this.data.password) || '两次密码输入不一致';
        }
      }
    }
  },
  methods: {
    getRegistryData () {
      let ret = this.Utility.clone(this.data);
      ret.tags = ret.tags && ret.tags.join(',');
      ret.password = md5(ret.password);
      return ret;
    },
    validate () {
      // if (!this.data.mobile) return '请填写注册手机号';
      // if (!this.data.smsCode) return '请填写手机短信验证码';
      // if (!this.data.password) return '请填写登录密码';
      // if (!this.data.rePassword || this.data.rePassword != this.data.password) return '两次密码输入不一致，请重新输入';
      // if (this.registryVerifyCode && !this.data.verifyCode) return '请输入图片验证码';
      return this.$refs.registryForm.validate();
      // return true;
    },
    tagSelected (item) {
      return this.data.tags.indexOf(item.name) != -1;
    },
    onToggleTag (item) {
      let idx = this.data.tags.indexOf(item.name);
      if (idx == -1) this.data.tags.push(item.name);
      else this.data.tags.splice(idx, 1);
    },
    onTagAdd () {
      this.tagAddFlag = true;
    },
    onTagRemove (index) {
      let name = this.coder_CLOUD_TAGS[index].name;
      let idx = this.data.tags.indexOf(name);
      if (idx != -1) this.data.tags.splice(idx, 1);
      this.coder_CLOUD_TAGS.splice(index, 1);
    },
    onTagAddOk (value) {
      if (value) {
        let fr = this.coder_CLOUD_TAGS.find(item => item.name == value);
        if (fr) {
          if (!this.tagSelected(fr)) this.data.tags.push(fr.name);
        } else {
          this.coder_CLOUD_TAGS.push({ code: value, name: value, default: false });
          this.data.tags.push(value);
        }
      }
      this.tagAddFlag = false;
    },
    onRefreshVerifyCode () {
      this.verifyCodeUrl = `${this.Utility.userApi}/api/pub/verify/code?ts=${new Date().getTime()}`;
    },
    onGetRegistrySmsCode () {
      if (!this.data.mobile) {
        this.$emit('error', '请填写注册手机号');
        return;
      }
      // TODO 校验手机号码格式
      this.smsCodeDisabled = true;
      let i = 60;
      let removeTimer = () => {
        clearInterval(smsCodeTimer);
        smsCodeTimer = undefined;
        this.smsCodeDisabled = false;
        this.smsCodeText = '获取验证码';
      }
      let smsCodeTimer = setInterval(() => {
        if (i < 0) removeTimer();
        else this.smsCodeText = `重新发送${i--}`;
      }, 1000);
      getRegistrySmsCode(this.data.mobile).then((res) => {
        if (res.status < 0) {
          this.$emit('error', res.message);
          removeTimer();
          return;
        }
        this.$message.success('验证码已发送，请注意查收');
      })
    }
  },
  created () {
    getCoder(['CLOUD_TAGS']).then(res => this.coder_CLOUD_TAGS = res.data && res.data['CLOUD_TAGS'])
  }
}
  </script>